'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = tokenRequester;

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tokens = {};

function handleTokenFailure(response, tokenRequestUrl) {
    tokens[tokenRequestUrl] = undefined;
    console.error('Could not acquire an e-conomic api authentication token', response.message);
    throw response;
}

function tokenRequester(tokenRequestUrl, tokenTimeout) {
    var now = new Date().getTime();
    var currentToken = tokens[tokenRequestUrl];
    var hasToken = currentToken && currentToken.authTokenPromise;
    var isExpired = hasToken && (now >= currentToken.authTokenExpirationTime || !currentToken.authTokenExpirationTime);

    if (!hasToken || isExpired) {
        tokens[tokenRequestUrl] = {
            authTokenExpirationTime: new Date(now + tokenTimeout * 0.9 * 60 * 1000),
            authTokenPromise: _axios2.default.get(tokenRequestUrl + '/?t=' + now).then(function (response) {
                return response.data;
            }).catch(handleTokenFailure)
        };
    }

    return tokens[tokenRequestUrl].authTokenPromise;
}